export enum SnippetProduct {
	// Only Confluence is allowed currently but more will be added:
	// 		https://bitbucket.org/atlassian/block-service/src/main/nebulae/seeding/ers/schemas
	CONFLUENCE = 'CONFLUENCE',
}
